module.exports = __webpack_public_path__ + "static/media/teacher-standing.51bc402c.png";